(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/hooks/use-lotto-rule-change.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/hooks/use-lotto-rule-change.js');

'use strict';

const {
  useState,
  useEffect
} = React;
const {
  useFetchDraws
} = svs.numbergames.prolong_game.hooks;
const {
  firstPlayableDraw
} = svs.numbergames.draws.drawsApi;
const useLottoRuleChange = (productName, price, selectedDays, drawCount) => {
  const [isShowRuleChangeInfo, setIsShowRuleChangeInfo] = useState(false);
  const [isNewRules, setIsNewRules] = useState(false);
  const {
    isFirstPlayableDraws
  } = useFetchDraws(productName);
  useEffect(() => {
    const draws = firstPlayableDraw(selectedDays);
    if (draws && Object.keys(draws).length !== 0) {
      var _isFirstPlayableDraws;
      const {
        productItsId
      } = Object.values(draws).sort((a, b) => new Date(a === null || a === void 0 ? void 0 : a.regCloseTime) - new Date(b === null || b === void 0 ? void 0 : b.regCloseTime))[0];
      const {
        drawNumber,
        productId
      } = (_isFirstPlayableDraws = isFirstPlayableDraws[productItsId]) !== null && _isFirstPlayableDraws !== void 0 ? _isFirstPlayableDraws : {};
      const ruleChangeInfo = selectedDays.some(productItsId => {
        var _isFirstPlayableDraws2;
        const {
          drawNumber
        } = (_isFirstPlayableDraws2 = isFirstPlayableDraws[productItsId]) !== null && _isFirstPlayableDraws2 !== void 0 ? _isFirstPlayableDraws2 : {};
        return svs.numbergames.rules.utils.lotto.showRuleChangeInfo({
          product: productItsId,
          firstDraw: drawNumber,
          lastDraw: drawNumber + parseInt(drawCount, 10) - 1
        });
      });
      setIsShowRuleChangeInfo(ruleChangeInfo);
      setIsNewRules(svs.numbergames.rules.utils.lotto.isNewRules({
        drawNumber,
        product: productId
      }));
    }
  }, [productName, price, selectedDays, isFirstPlayableDraws, drawCount]);
  return {
    isShowRuleChangeInfo,
    isNewRules
  };
};
setGlobal('svs.numbergames.prolong_game.hooks.useLottoRuleChange', useLottoRuleChange);

 })(window);